import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthUser} from '../../../../interfaces/data.interfaces';
import {SettingsService} from '../../../../../services/settings.service';
import {Observable, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-portal-landing-page',
    templateUrl: './portal-landing-page.component.html',
    styleUrls: ['./portal-landing-page.component.scss'],
    standalone: false
})
export class PortalLandingPageComponent implements OnInit, OnDestroy{

  images = this.settingsService.getSliderImages();

  institutions = [
    {
      subTitle: 'tfb',
      logo: '/assets/images/bg/6.webp',
      link: '/portal-tfb',
      // tslint:disable-next-line:align
      description: 'Kuitangaza Tanzania kama eneo adhimu la upigaji picha za filamu kwa ajili ya uimarishaji wa uchumi na ajira kupitia uendelezaji wa sekta mahiri ya filamu na televisheni.',
    },
    {
      subTitle: 'basata',
      link: '/portal-basata',
      logo: '/assets/images/bg/1.webp',
      description: 'Kurahisisha uzalishaji, matumizi, uuzaji na ushiriki katika kazi zenye ubora wa juu.'
    },
    {
      subTitle: 'my-profile',
      link: '/profile',
      logo: '/assets/images/bg/2.webp',
      description: 'Taarifa Binafsi, ikiwemo NIDA, TIN Number nambari ya simu'
    }
  ];

  currentImage: string = this.images[0];
  imageIndex = 0;

  subscriptions: Subscription = new Subscription();

  user$: Observable<AuthUser>;

  constructor(
    public settingsService: SettingsService,
    public translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.settingsService.loadTranslation();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
